import { useContext } from 'react';

import AppContext from '../Components/AppContext';

export default function useApp() {
  return useContext(AppContext);
}
